import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TopBarComponent } from 'src/app/top-bar/top-bar.component';
import { OperationsComponent } from '../../operations.component';
import { FilterService, GridComponent } from '@syncfusion/ej2-angular-grids';
import { ANGULAR_MODULES, GENERAL_COMPONENTS, Operational_COMPONENTS, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SalesPersonService } from '../../../services/SalesPerson.service';
import { UserService } from '../../../services/User.service';
import { GeneralService } from '../../../services/general.service';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { EActionTypes, EToaster, EUserSecurityFunctionID } from "src/app/Shared/enum";
import { IUserPermissionHandler } from "src/app/Shared/model/CommonModel";
import { UserPermissionHandlerDirective } from "src/app/Shared/userPermissionHandler.directive";
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import '@angular/localize/init';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
declare var $: any;


@Component({
  selector: 'app-ops-sales-person',
  standalone: true,
  imports: [TopBarComponent, SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, UserPermissionHandlerDirective, LoaderComponent],
  providers: [FilterService],
  templateUrl: './ops-sales-person.html',
  styleUrl: './ops-sales-person.scss'
})
export class OpsSalesPerson {
  logoPreviewUrl: string = './assets/images/NoPhoto.svg';
  @ViewChild('gridSalesPerson', { static: false }) public gridSalesPerson: GridComponent;
  @ViewChild('salesPersonModal', { static: false }) salesPersonModal: ElementRef;

  @Input() activeColor: string = '#28a745';
  @Input() inactiveColor: string = '#dc3545';

  public PhoneNumberMask: String = '(000)000-0000';

  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.SalesPerson, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.SalesPerson, Action: EActionTypes.CREATE };
  deletePermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.SalesPerson, Action: EActionTypes.DELETE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.SalesPerson, Action: EActionTypes.EDIT };

  constructor(private salesPersonService: SalesPersonService, private userService: UserService, private generalService: GeneralService, private formbuilder: FormBuilder, private toastr: ToastrService, private router: Router,
    private sharedHTMLSettings: SharedHTMLSettingsDataService) {

    this.SalesPersonForm = this.formbuilder.group({
      selectedUserId: [null],
      salesPersonID: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      email: ['', [Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$')]],
      mobile: ['', [Validators.pattern('^[0-9][0-9]{9}$')]],
      city: [''],
      state: [null],
      zipcode: [''],
      salesActive: [true],
      photoFileName: [''],
      uploadedPhotoContent: [''],
      deletePhoto: [false]
    })

  }
  isCollapsed = true;
  private subscriptions: Subscription[] = [];
  salesPerson
  salesPersonId
  firstName
  lastName
  mobile
  city
  state
  zipcode
  email
  salesData: any[] = [];
  userList: any[] = [];
  stateList: any[] = [];
  selectedUserId: number;
  salesPersonList: any[] = [];
  SalesPersonForm: FormGroup;
  isEditMode = false;
  activeTab: 'All' | 'Active' | 'Inactive' = 'All';
  allSalesData: any[] = [];
  loaderIcon: Promise<boolean> = Promise.resolve(false);

  ngOnInit(): void {
    this.getUserList();
    this.getSalesPersonDetails();
    this.getStates();
  }

  getSalesPersonDetails() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(
      this.salesPersonService.getSalesPersonDetails().subscribe({
        next: (res: any) => {
          if (res) {
            this.allSalesData = res.map((item: any) => ({
              ...item,
              firstName: item.FirstName,
              lastName: item.LastName,
              email: item.Email,
              mobiles: item.Mobiles,
              city: item.City,
              StateName: item.StateName,
              zip: item.Zip,
              status: item.ActiveSalesPerson ? 'Active' : 'Inactive',
              selectedUserId: item.UserID
            }));

            this.onTabChange(this.activeTab);
          }
          this.loaderIcon = Promise.resolve(false);
        },
        error: () => {
          this.toastr.error('Failed to load salespersons.', 'Error', this.sharedHTMLSettings.ToasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      })
    );
  }

  dataBound(args) {
    Object.assign((<any>this.gridSalesPerson.filterModule).filterOperators, { startsWith: 'contains' });
  }

  getUserList() {
    this.subscriptions.push(
      this.userService.getUserList().subscribe((res: any[]) => {
        if (res) {
          this.userList = res;
        }
      })
    );
  }

  getStates() {
    this.subscriptions.push(
      this.generalService.getStates(1).subscribe((res: any[]) => {
        if (res) {
          this.stateList = res;
        }
      })
    );
  }

  resetFormWithDefaults() {
    this.SalesPersonForm.reset({
      selectedUserId: null,
      salesPersonID: '',
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
      city: '',
      state: null,
      zipcode: '',
      salesActive: true,
      photoFileName: '',
      uploadedPhotoContent: '',
      deletePhoto: false
    });
    this.logoPreviewUrl = './assets/images/NoPhoto.svg';
  }

  onRowSelected(event: any): void {    
    this.isEditMode = true;
    const data = event.data;
    console.log('Selected Row:', data);

    this.salesPersonId = data.SalesPersonID;
    this.logoPreviewUrl = data.PhotoFileURL ? data.PhotoFileURL : './assets/images/NoPhoto.svg';
    this.SalesPersonForm.patchValue({
      selectedUserId: data.selectedUserId ?? null,
      salesPersonID: data.SalesmanId,
      firstName: data.FirstName,
      lastName: data.LastName,
      email: data.Email,
      mobile: data.Mobiles,
      city: data.City,
      state: Number(data.StateID),
      zipcode: data.Zip,
      salesActive: data.ActiveSalesPerson,
      photoFileName: '',
      uploadedPhotoContent: '',
      deletePhoto: false
    });
    this.SalesPersonForm.markAsPristine();
    // Open modal
    const modal = this.salesPersonModal.nativeElement;
    $(modal).modal('show');
    modal.classList.add('show');
  }

  saveSalesPersonDetails(): void {
    if (this.SalesPersonForm.invalid) {
      this.SalesPersonForm.markAllAsTouched(); // Show errors
      return;
    }
    this.getSalesPersonDetails();
    const enteredSalesmanId = (this.SalesPersonForm.get('salesPersonID')?.value || '').trim().toLowerCase();
    const currentRecordId = this.salesPersonId ?? 0;

    const isDuplicate = this.allSalesData.some((person: any) => {
      const existingSalesmanId = (person.SalesmanId || '').trim().toLowerCase();
      const existingSalesPersonId = person.SalesPersonID || 0;
      return existingSalesmanId === enteredSalesmanId && existingSalesPersonId !== currentRecordId;
    });

    if (isDuplicate) {
      this.toastr.error(
        'Salesperson ID already exists. Please enter a different ID.',
        'Duplicate ID', this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }

    const obj = {
      SalesPersonID: this.salesPersonId,
      UserId: this.SalesPersonForm.get('selectedUserId')?.value,
      SalesmanId: this.SalesPersonForm.get('salesPersonID').value,
      FirstName: this.SalesPersonForm.get('firstName').value,
      LastName: this.SalesPersonForm.get('lastName').value,
      //Address: this.SalesPersonForm.get('address').value,
      City: this.SalesPersonForm.get('city').value,
      StateID: String(this.SalesPersonForm.get('state')?.value),
      Zip: this.SalesPersonForm.get('zipcode').value,
      Mobiles: this.SalesPersonForm.get('mobile').value,
      Email: this.SalesPersonForm.get('email').value,
      CreationDate: new Date().toISOString(),
      LastUpdatedDate: new Date().toISOString(),
      ActiveSalesPerson: this.SalesPersonForm.get('salesActive').value,
      PhotoFileName: this.SalesPersonForm.get('photoFileName')?.value,
      UploadedPhotoContent: this.SalesPersonForm.get('uploadedPhotoContent')?.value,
      DeletePhoto: this.SalesPersonForm.get('deletePhoto')?.value
    }

    Swal.fire({

      title: $localize`Confirm`,
      text: $localize`Are you sure you want to save this salesperson details?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.salesPersonService.saveSalesPersonDetails(obj).subscribe({
          next: (response) => {
            this.toastr.success('Salesperson has been saved successfully.', 'Saved!', this.sharedHTMLSettings.ToasterConfig);
            this.salesPersonId = response.Id;
            this.saveSalesPersonPhoto(false);
            this.getSalesPersonDetails();
            this.resetFormWithDefaults();
            const modal = this.salesPersonModal.nativeElement;
            $(modal).modal('hide');
          },
          error: (err) => {
            console.error('Save failed:', err);
            this.toastr.error('Failed to save salesperson.', 'Error', this.sharedHTMLSettings.ToasterConfig);
          }
        });
      }
    });
  }

  deleteSalesPerson(id: number): void {
    Swal.fire({

      title: $localize`Confirm`,
      text: $localize`Are you sure you want to delete this salesperson?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.salesPersonService.deleteSalesPerson(id).subscribe({
          next: (res) => {
            if (res && res.Success) {
              this.salesPersonList = this.salesPersonList.filter(p => p.SalesPersonID !== id);
              this.getSalesPersonDetails();
              this.toastr.success('Salesperson has been deleted.', 'Deleted!', this.sharedHTMLSettings.ToasterConfig);
            } else {
              this.toastr.warning('Unable to delete salesperson! As there are transactions for selected Sales Person', 'Warning', this.sharedHTMLSettings.ToasterConfig);
            }
          },
          error: (err) => {
            console.error('Delete failed:', err);
            this.toastr.error('Failed to delete salesperson.', 'Error', this.sharedHTMLSettings.ToasterConfig);
          }
        });
      }
    });
  }

  onNewClick() {
    this.resetFormWithDefaults();
    this.salesPersonId = 0;
    this.isEditMode = false;
    const modal = this.salesPersonModal.nativeElement;
    $(modal).modal('show');
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Block non-numeric input
    }
  }

  public created(args1) {
    this.gridSalesPerson.element.querySelectorAll('.e-filterdiv')[this.gridSalesPerson.getColumnIndexByField('mobiles')].classList.add('e-hide');
    this.gridSalesPerson.element.querySelectorAll('.e-filterdiv')[this.gridSalesPerson.getColumnIndexByField('Delete')].classList.add('e-hide');
    this.gridSalesPerson.element.querySelectorAll('.e-filterdiv')[this.gridSalesPerson.getColumnIndexByField('status')].classList.add('e-hide');


    this.gridSalesPerson.selectionSettings = { checkboxMode: 'ResetOnRowClick', mode: 'Row', type: 'Single', enableSimpleMultiRowSelection: false, checkboxOnly: false };
    this.gridSalesPerson.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };

  }

  onLogoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.logoPreviewUrl = reader.result as string;
        this.SalesPersonForm.patchValue({
          uploadedPhotoContent: this.logoPreviewUrl.split(',')[1],
          photoFileName: file.name,
          deletePhoto: false
        });
        this.SalesPersonForm.markAsDirty();
      };
      reader.readAsDataURL(file);
    }
  }


  addPhoto(): void {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.onchange = (e) => this.onLogoSelected(e as any);
    fileInput.click();
  }

  removePhoto() {
    this.logoPreviewUrl = './assets/images/NoPhoto.svg';

    this.SalesPersonForm.patchValue({
      uploadedPhotoContent: '',
      photoFileName: '',
      deletePhoto: true
    });
    this.SalesPersonForm.markAsDirty();
  }

  saveSalesPersonPhoto(showAlert: boolean = true): Promise<void> {
    return new Promise((resolve) => {
      const payload = {
        SalesPersonID: this.salesPersonId,
        PhotoName: this.SalesPersonForm.get('photoFileName')?.value,
        UploadedPhotoBase64: this.SalesPersonForm.get('uploadedPhotoContent')?.value,
        DeleteFlag: this.SalesPersonForm.get('deletePhoto')?.value
      };

      if (!payload.UploadedPhotoBase64 && !payload.DeleteFlag) {
        resolve();
        return;
      }

      const actionText = payload.DeleteFlag ? 'delete' : 'add';
      const performSave = () => {
        this.salesPersonService.saveSalesPersonPhoto(payload).subscribe({
          next: (res: any) => {
            if (!payload.DeleteFlag && res.PhotoUrl) {
              this.logoPreviewUrl = `${res.PhotoUrl}?v=${Date.now()}`;
              const index = this.salesData.findIndex(p => p.SalesPersonID === this.salesPersonId);
              if (index !== -1) {
                this.salesData[index].PhotoFileURL = this.logoPreviewUrl;
              }
            } else if (payload.DeleteFlag) {
              this.logoPreviewUrl = './assets/images/NoPhoto.svg';
              const index = this.salesData.findIndex(p => p.SalesPersonID === this.salesPersonId);
              if (index !== -1) {
                this.salesData[index].PhotoFileURL = '';
              }
            }

            this.SalesPersonForm.patchValue({
              uploadedPhotoContent: '',
              photoFileName: '',
              deletePhoto: false
            });

            if (showAlert) {
              const message = payload.DeleteFlag ? 'Salesperson photo deleted' : 'Salesperson photo saved';
              this.toastr.success(message, 'Success', this.sharedHTMLSettings.ToasterConfig);
            }
            resolve();
          },
          error: (err) => {
            console.error('Failed to save photo', err);
            if (showAlert) {
              this.toastr.error('Failed to save photo', 'Error', this.sharedHTMLSettings.ToasterConfig);
            }
            resolve();
          }
        });
      };

      if (showAlert) {
        Swal.fire({
          title: `Are you sure you want to ${actionText} the photo?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: `Yes, ${actionText} it`,
          cancelButtonText: 'Cancel',
        }).then((result) => {
          if (result.isConfirmed) performSave();
          else resolve();
        });
      } else {
        performSave();
      }
    });
  }

  onTabChange(tab: 'All' | 'Active' | 'Inactive') {
    this.activeTab = tab;

    if (tab === 'Active') {
      this.salesData = this.allSalesData.filter(x => x.ActiveSalesPerson === true);
    }
    else if (tab === 'Inactive') {
      this.salesData = this.allSalesData.filter(x => x.ActiveSalesPerson === false);
    }
    else {
      this.salesData = [...this.allSalesData];
    }
  }

  routeBack() {
    if (this.SalesPersonForm.dirty) {
      const modalEl = this.salesPersonModal.nativeElement;
      const $modal = $(modalEl);

      $modal.data('bs.modal')?._config && ($modal.data('bs.modal')._config.backdrop = 'static');
      $modal.data('bs.modal')?._config && ($modal.data('bs.modal')._config.keyboard = false);

      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Unsaved changes will be lost. Are you sure you want to continue?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/Maintenance/SalesPerson']);
        } else {

          setTimeout(() => {
            if (!$modal.hasClass('show')) {
              $modal.modal('show');
            }
            $(modalEl).focus();
          }, 100);
        }
      });
    } else {
      this.router.navigate(['/Maintenance/SalesPerson']);
    }
  }

  formatPhoneNumber(phone: string | null | undefined): string {
    if (!phone) {
      return '';
    }

    const digits = phone.replace(/\D/g, '');

    if (digits.length === 10) {
      return `(${digits.substring(0, 3)})${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
    }

    return phone;
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
